module.exports = __webpack_public_path__ + "static/service03-955eeb57c731044838799a18668e3cd3.jpg";